//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('p2ExportProcs', {
//        templateUrl: 'views/components/views/p2ExportProcs/p2ExportProcs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'p2ExportProcsService', function (stateService, p2ExportProcsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                itemsListExportProcedures: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadExportProcedures() {
//                vm.model.itemsListExportProcedures = await p2ExportProcsService.listExportProcedures();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'p2exportproc':
//                        go({ p2_exportproc_keyno: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadExportProcedures();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
